import React, { useState, useEffect } from 'react';
import { FaFileExcel, FaBuilding, FaMapMarkerAlt } from 'react-icons/fa'; // Import icon for cadastral code
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const pulseAnimation = keyframes`
    0% { transform: scale(1); }
    50% { transform: scale(1.1); }
    100% { transform: scale(1); }
`;

const ExcelIcon = styled(FaFileExcel)`
    color: #28a745; /* Excel green */
    font-size: 60px;
    animation: ${pulseAnimation} 2s infinite ease-in-out;
`;

const CompanyIcon = styled(FaBuilding)`
    color: #007bff; /* Blue for company */
    font-size: 60px;
    animation: ${pulseAnimation} 2s infinite ease-in-out;
`;

const CadastralCodeIcon = styled(FaMapMarkerAlt)`  /* New icon for Cadastral Code */
    color: #ff4500; /* Orange for cadastral code */
    font-size: 60px;
    animation: ${pulseAnimation} 2s infinite ease-in-out;
`;

function ExcelPopup({ isVisible, loaderText = "მიდინარეობს მონაცემების ექსპორტი", loaderType = "Excel" }) {
    const [dots, setDots] = useState('');
    const isMobile = window.innerWidth < 768;


    useEffect(() => {
        const interval = setInterval(() => {
            setDots(prevDots => (prevDots.length < 3 ? prevDots + '.' : ''));
        }, 500);

        return () => clearInterval(interval);
    }, []);

    return (
        <Dialog
            open={isVisible}
            aria-labelledby="excel-export-loading"
            style={{zIndex: 999999}}
            PaperProps={{
                style: {
                    backgroundColor: 'white',
                    borderRadius: 15,
                    padding: '10px',
                    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
                    zIndex: 999999, // Increased z-index
                }
            }}
        >
            <DialogContent style={{ textAlign: 'center' }}>
                {loaderType === "Excel" && (
                    <ExcelIcon />
                )}
                {loaderType === "CompanyInfo" && (
                    <CompanyIcon />
                )}
                {loaderType === "CadastralCode" && ( /* New loader type for Cadastral Code */
                    <CadastralCodeIcon />
                )}

                <Typography variant="body1" style={{ marginTop: '20px', color: '#555', minWidth: isMobile ? 0 : 400 }}>
                    {loaderText}{dots}
                </Typography>
                <CircularProgress
                    style={{
                        marginTop: '20px',
                        color: loaderType === "Excel"
                            ? '#28a745'
                            : loaderType === "CompanyInfo"
                                ? '#007bff'
                                : '#ff4500'  /* Orange color for Cadastral Code */
                    }}
                />
            </DialogContent>
        </Dialog>
    );
}

export default ExcelPopup;
